import request from '@/utils/request'
import store from '../store'
import cryptoJs from 'crypto-js'
const KEY = cryptoJs.enc.Utf8.parse('f9e0f22c7654759c1fe34715a85c14bd')// ""与后台一样  Key
const IV = cryptoJs.enc.Utf8.parse('1bcb557446027305')// ""中与后台一样

export function getData (f, data, IsCache) {
  if (typeof (IsCache) === 'undefined') {
    IsCache = true
  }
  if (typeof (data) === 'undefined') {
    data = {}
  }

  if (f != 'FA_WEB_USERLOGIN' && f != 'FA_WEB_QUERYACCOUNT') {
    data['FDBCString'] = store.getters.FDBCString
    data['FUserID'] = store.getters.UserID
  }

  return request({
    url: '/',
    method: 'post',
    data: {
      'f': f,
      'v': aes(data),
      'EID': store.getters.EID,
      'Moblie': 'web',
      'IsCache': IsCache
    }
  })
}

export function getDataEID (f, EID, data, IsCache) {
  if (typeof (IsCache) === 'undefined') {
    IsCache = true
  }
  if (typeof (data) === 'undefined') {
    data = {}
  }

  if (f != 'FA_WEB_USERLOGIN' && f != 'FA_WEB_QUERYACCOUNT') {
    data['FDBCString'] = store.getters.FDBCString
    data['FUserID'] = store.getters.UserID
  }

  return request({
    url: '/',
    method: 'post',
    data: {
      'f': f,
      'v': aes(data),
      'EID': EID,
      'Moblie': 'web',
      'IsCache': IsCache
    }
  })
}

function aes (word) {
  let key = KEY
  let iv = IV
  let srcs = ''
  if (typeof word === 'string') {
    srcs = word
  } else if (typeof word === 'object') {
    srcs = JSON.stringify(word)
  }
  var encrypted = cryptoJs.AES.encrypt(srcs, key, {
    iv: iv,
    mode: cryptoJs.mode.CBC, // 使用偏移量
    padding: cryptoJs.pad.Pkcs7
  })

  let result = cryptoJs.enc.Base64.stringify(encrypted.ciphertext)
  return result
}



// WEBPACK FOOTER //
// ./src/api/api.js